export function hide_brand_info() {
    $(this).removeClass('hoverintent');
}